module.exports = __webpack_public_path__ + "img/country.cb83705c.svg";